import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { useFlags } from 'Hooks/useFlags';
import { routes } from 'Constants/routes';
import { FRONT_PLANS } from 'Constants/plans';
import { FlagsKey } from 'Types/common';
import * as Styled from './styles';
import { UpsellingButtonProps } from './types';

const UpsellingButton = ({ plan }: UpsellingButtonProps): JSX.Element | null => {
  const { t } = useTranslation(locizeNS.PLANS);
  const { enabled } = useFlags(FlagsKey.MGM_FLOW_ENABLED);
  const handleOnClick = (): void => {
    history.push(routes.PLANS);
  };

  const handleOnClickReferral = (): void => {
    history.push(routes.REFERRAL);
  };

  return plan === FRONT_PLANS.BASIC ? (
    <Styled.MGMButton
      type={plan}
      size="xs"
      onClick={handleOnClick}
      testID="buttonSubmit"
      label={t('Plans.header.Pro.button')}
    />
  ) : !enabled ? (
    <Styled.MGMButton
      type={FRONT_PLANS.BASIC}
      size="xs"
      onClick={handleOnClickReferral}
      testID="buttonSubmit"
      label={t('Plans.header.invite.button')}
    />
  ) : null;
};

export default UpsellingButton;
